import { render, staticRenderFns } from "./Loyalties.vue?vue&type=template&id=4cc55f86&scoped=true"
import script from "./Loyalties.vue?vue&type=script&lang=js"
export * from "./Loyalties.vue?vue&type=script&lang=js"
import style0 from "./Loyalties.vue?vue&type=style&index=0&id=4cc55f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc55f86",
  null
  
)

export default component.exports